const updateEditorState = data => {
    return {
        type: 'UPDATE_EDITOR_STATE',
        data: data,
    }
}

const replaceText = data => {
    return {
        type: 'REPLACE_EDITOR_STATE',
        data: data,
    }
}

const addWordToIgnoreList = data => (dispatch, getState) => {
    const allKeys = getState().editorState.data.getCurrentContent().getBlocksAsArray().map(contentBlock => {
        return contentBlock.getKey()
    })
    dispatch({
        type: 'ADD_WORD',
        data: data.word,
    })
    setTimeout(function(){ 
        allKeys.forEach(key => {
            dispatch({
                type: 'BODGEY_TEXT_THING',
                data: key,
            })
            dispatch({
                type: 'REMOVE_BODGEY_TEXT_THING',
                data: key,
            })
        })
     }, 5);
}

export { updateEditorState, replaceText, addWordToIgnoreList }
